/*
 * Copyright 2024 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { makeStyles } from "@material-ui/core";

export const useWorkspaceSwitcherSelectStyles = makeStyles(() => ({
    input: {
        "& .MuiInputBase-root": {
            height: "64px",
        },
        "& fieldset": {
            borderBlock: "none",
            borderRadius: 0,
        },
    },
}));
